var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.291 31.1826L23.0789 5.21286C21.7031 2.86134 18.3031 2.86134 16.9213 5.21286L1.70919 31.1826C0.315249 33.5583 2.0304 36.5522 4.78798 36.5522H35.2183C37.9698 36.5522 39.6849 33.5644 38.291 31.1826ZM20.0001 11.4735C21.3274 11.4735 22.3819 12.5947 22.3092 13.9219L21.6365 25.3644H18.3637L17.691 13.9219C17.6183 12.5947 18.6728 11.4735 20.0001 11.4735ZM20.0001 32.7159C18.6486 32.7159 17.5516 31.6189 17.5516 30.2674C17.5516 28.9159 18.6486 27.8189 20.0001 27.8189C21.3516 27.8189 22.4486 28.9159 22.4486 30.2674C22.4486 31.6189 21.3516 32.7159 20.0001 32.7159Z",
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/AlertIcon.38f16d4e76009563c3b294025bcff861.svg";
export { ForwardRef as ReactComponent };